import { render, staticRenderFns } from "./Table-people.vue?vue&type=template&id=bf865ce6&"
import script from "./Table-people.vue?vue&type=script&lang=js&"
export * from "./Table-people.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports